import { toast } from 'sonner';

/* Non-component helpers for the discussion vocabulary. Kept out of
   Discussion.tsx so that file only exports components (fast refresh),
   matching Collection.tsx / collection-lib.ts. */

export const discussionKeys = {
  list: ['bookclub', 'discussions'] as const,
  thread: (id: number) => ['bookclub', 'discussion', id] as const,
};

export const timeAgo = (iso: string): string => {
  const mins = Math.round((Date.now() - new Date(iso).getTime()) / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.round(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.round(hours / 24);
  return days === 1 ? 'yesterday' : `${days}d ago`;
};

/* The API answers 2xx with a CONTENT_FLAGGED marker rather than an error
   when the toxicity scan holds a post, so say so instead of "posted". */
export const flaggedNotice = (res: { warning?: string }, ok: string) => {
  if (res.warning === 'CONTENT_FLAGGED') {
    toast.warning('Held for a librarian to review before it appears.');
  } else {
    toast.success(ok);
  }
};

export const apiErrorMessage = (e: unknown, fallback: string): string => {
  const data = (e as { response?: { data?: { error?: unknown; message?: unknown } } })?.response
    ?.data;
  if (typeof data?.error === 'string') return data.error;
  const nested = (data?.error as { message?: unknown } | undefined)?.message;
  if (typeof nested === 'string') return nested;
  if (typeof data?.message === 'string') return data.message;
  return fallback;
};
